export enum RollDetailsPath {
  manifestNumber = "manifestNumber"
}

export interface PathParams {
  [RollDetailsPath.manifestNumber]: string;
}
